// extracted by mini-css-extract-plugin
export default {"container":"tableDnD_container__gVh+f","table":"tableDnD_table__aRCz5","draggable":"tableDnD_draggable__R0O2g"};